import React from "react";
import {
  Box,
  CircularProgress,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Tile from "../../types/tile";
import {
  AlarmOn,
  AssignmentInd,
  BatteryChargingFull,
  Business,
  DirectionsCar,
  Videocam,
  Warning,
} from "@mui/icons-material";
import { useSelector } from "../../store";
import { TileTypes } from "../../types/tileType";
import theme from "../../theme";

interface Props {
  tileModel: Tile;
  detail?: boolean;
}

const CountTile: React.FC<Props> = (props) => {
  const { tileModel, detail } = props;

  const { tileDetailStatus } = useSelector((store) => store.tiles);

  const getIcon = () => {
    switch (tileModel.tileIconType?.id) {
      case 1:
        return <AssignmentInd fontSize="inherit" />;
      case 2:
        return <Videocam fontSize="inherit" />;
      case 3:
        return <DirectionsCar fontSize="inherit" />;
      case 4:
        return <AlarmOn fontSize="inherit" />;
      case 5:
        return <BatteryChargingFull fontSize="inherit" />;
      case 6:
        return <Warning fontSize="inherit" />;
      case 7:
        return <Business fontSize="inherit" />;
      case 8:
        return;
      default:
        return <AssignmentInd fontSize="inherit" />;
    }
  };

  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      sx={{ width: "100%", height: "100%" }}
      justifyContent="center"
      position="absolute"
      top={{
        xs: detail ? "-5vh" : "",
        sm: detail ? "-8vh" : "",
        md: detail ? "-15vh" : "-30px",
        lg: detail ? "-35px" : "",
      }}
      paddingX={{ xs: 0, md: "5px" }}
      paddingBottom={{ xs: "95px", md: "90px" }}
    >
      {!!detail &&
      tileDetailStatus === "loading" &&
      (!tileModel.value || tileModel.value === "") ? (
        <CircularProgress />
      ) : (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          sx={{ width: "100%", height: "100%" }}
        >
          <Typography
            display="flex"
            flexDirection="row"
            alignItems="center"
            color="#fff"
            fontSize={
              lg
                ? "7vw"
                : md
                ? detail
                  ? "25vw"
                  : "7vw"
                : sm
                ? detail
                  ? "28vw"
                  : "10vw"
                : detail
                ? "22vw"
                : "9vw"
            }
            padding={0}
          >
            {getIcon()}
          </Typography>

          <Typography
            display="flex"
            flexDirection="row"
            alignItems="center"
            sx={{
              color: "#fff",
              fontSize: lg
                ? detail
                  ? "5vw"
                  : "4vw"
                : md
                ? detail
                  ? "14vw"
                  : "4vw"
                : sm
                ? detail
                  ? "15vw"
                  : "6vw"
                : detail
                ? "12vw"
                : "6vw",
            }}
          >
            {tileModel.value}
          </Typography>

          {!!tileModel.total && (
            <Typography
              sx={{
                color: "#fff",
                fontSize:
                  tileModel.tileIconType?.id === TileTypes.Number
                    ? `clamp(22px, 3vw, 45px)`
                    : `clamp(16px, 2vw, 35px)`,
              }}
            >
              {tileModel.total ? " out of " + tileModel.total : ""}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default CountTile;
